import allImgPaths from 'assets/images'
import Tooltip from 'components/common/tooltip/Tooltip'
import React from 'react'

const HistoryThemeBox = ({ data }: any) => {
    return (
        <>
            <div className="border border-[#E6E6E6] rounded-lg p-2 shadow-customShadow10 mb-3 bg-[#fff] ml-14 overflow-x-auto">
                <div className={`flex gap-x-1.5 w-[calc(100vw_-1300px)]`} >
                    {
                        data.map((nv: any, index: number) => (
                            <div className='border border-[#D8D8D8] px-2 py-2 rounded-[10px] bg-[#fff] w-[280px] flex-shrink-0 hover:shadow-xl' key={index}>
                                <div className='relative'>
                                    <div className='h-[190px] rounded-[10px] mb-2.5'>
                                        <img
                                            className={`rounded-[10px] w-full h-full object-cover mb-2`}
                                            src={data?.imageUrl ? data.imageUrl : allImgPaths.dummyImg}
                                            alt=''
                                        />
                                    </div>
                                    <h5 className='text-[#101828] font-interSemiBold text-lg px-0.5 pb-2 truncate max-w-96'>
                                        {nv?.title}
                                    </h5>
                                    <div>
                                        {nv?.imageDescription || nv?.description || 'No description available'}
                                    </div>
                                    {
                                        nv?.tags?.length &&
                                        <div className="flex flex-wrap gap-1.5 mt-5 mb-1 items-start h-[50px]">
                                            {
                                                nv?.tags?.slice(0, 4).map((tag: any, tagIndex: number) => (
                                                    <span key={tagIndex} className="text-xs font-interSemiBold text-[#363F72] border border-[#D5D9EB] rounded bg-[#F8F9FC] py-0.5 px-1">
                                                        {tag}
                                                    </span>
                                                ))
                                            }

                                            {
                                                nv?.tags?.length > 4 &&
                                                <div className="relative group cursor-pointer leading-[1.25]">
                                                    <span className="text-xs font-interSemiBold text-[#363F72] border border-[#D5D9EB] rounded bg-[#F8F9FC] py-0.5 px-1">
                                                        + {(nv.tags.slice(4).length)}
                                                    </span>
                                                    <Tooltip list={nv.tags.slice(4).map((item: any) => ({ _id: item, name: item }))} />
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div >
        </>
    )
}

export default HistoryThemeBox